import UserInfo from '@/modules/UserInfo';
import style from '@/components/MainLayout/Layout.module.scss';
import Heading from '@/components/Heading';
import usePathname from '@/hooks/navigationSection.tsx';
import { ReactNode } from 'react';
interface LayoutProps {
  sideBarContent?: ReactNode;
  mainContent: ReactNode;
}

const MainLayout = ({ sideBarContent, mainContent }: LayoutProps) => {
  const navigationSectionName = usePathname();

  return (
    <div className={`flex ${style.main__layout__container}`}>
      <main className="flex-1">
        <div className={style.heading__borderBottom}>
          <Heading
            className={`${style.heading__bgColor} ${style.heading__spacing}`}
            title={navigationSectionName}
            showHeadingLogo={true}
          >
            <UserInfo />
          </Heading>
        </div>
        <div className={style.layout__sidebar__content__container}>
          {sideBarContent}
          <div className={style.layout__main__content__container}>{mainContent}</div>
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
